import { AfterViewInit, Component, Input, OnInit } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
// import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute } from "@angular/router";
import { NgxGalleryImage, NgxGalleryOptions } from "ngx-gallery";
import { Lightbox } from "ngx-lightbox";
import { take } from "rxjs/operators";

declare const $: any;

@Component({
  selector: "app-blog-details",
  templateUrl: "./blog-details.component.html",
  styleUrls: ["./blog-details.component.css"],
})
export class BlogDetailsComponent implements OnInit, AfterViewInit {
  @Input() public settings: any;
  @Input() public data: any;
  public post: any = {};
  public month: any;
  public day: any;
  public monthNumber: any;
  public galleryOptions: NgxGalleryOptions[];
  public galleryImages: NgxGalleryImage[];
  public media: any[] = [];
  public catList: any[] = [];
  public tagList: any[] = [];
  public album: Array<any> = [];
  public addtionalMeta: any;

  constructor(
    private lightBox: Lightbox,
    private route: ActivatedRoute,
    private sinitizer: DomSanitizer
  ) {
    this.getFancybox();
  }
  // public setTitle(title: string): void {
  //   this.titleService.setTitle(title);
  // }

  public ngOnInit() {
    if (
      this.settings.relatedPostsSettings &&
      this.settings.relatedPostsSettings.component
    ) {
      this.settings.relatedPostsSettings.component.setting.selectedCategories = [];
    }

    this.route.data.pipe(take(1)).subscribe((res) => {
      if (res.data[0]) {
        this.setPost(res.data[0]);
      }
    });
  }

  public ngAfterViewInit() {
    if (this.settings.hoffset) {
      this.settings.hoffset = this.settings.hoffset + "px ";
    }
    if (this.settings.voffset) {
      this.settings.voffset = this.settings.voffset + "px ";
    }
    if (this.settings.blur) {
      this.settings.blur = this.settings.blur + "px ";
    }
    if (this.settings.spread) {
      this.settings.spread = this.settings.spread + "px ";
    }
    if (this.settings.boxcolor) {
      this.settings.boxcolor = this.settings.boxcolor;
    }

    const head = document.getElementsByTagName("head")[0];
    const style = document.createElement("style");
    const oldCss = document.getElementsByTagName("style");
    style.id = "blogCss";
    for (let index = 0; index < oldCss.length; index++) {
      const element = oldCss[index];
      if (element.id.indexOf("blogCss") !== -1) {
        head.removeChild(element);
        index = index - 1;
      }
    }
    const css =
      `
      #blog-` +
      this.settings.id +
      ` .blog-details ,.blog-leftl{
      box-shadow: ` +
      this.settings.hoffset +
      this.settings.voffset +
      this.settings.blur +
      this.settings.spread +
      this.settings.boxcolor +
      `;
    }
    #blog-` +
      this.settings.id +
      ` .blog-details ,.blog-leftl{
      padding-top: ` +
      this.settings.paddingtop +
      "px " +
      `;
      padding-right: ` +
      this.settings.paddingright +
      "px " +
      `;
      padding-bottom: ` +
      this.settings.paddingbottom +
      "px " +
      `;
      padding-left: ` +
      this.settings.paddingleft +
      "px " +
      `;
    }
    #blog-` +
      this.settings.id +
      ` .blog-leftl {
      background: ` +
      this.settings.background_color +
      `;
     }
    #blog-` +
      this.settings.id +
      ` .blog-leftl h4{
       color : ` +
      this.settings.font_color +
      `;
    }
    #blog-` +
      this.settings.id +
      ` .blog-leftl a{
      color : ` +
      this.settings.font_color +
      `;
   }
    `;

    style.appendChild(document.createTextNode(css));
    head.appendChild(style);
  }

  public setPost(res) {
    this.setGalleryOptions();
    this.setThemeClassesAndColors();

    if (res) {
      this.post = res;
      if (this.settings.related) {
        this.post.relatedCategoriesSettings = this.post
          .relatedCategoriesSettings
          ? JSON.parse(this.post.relatedCategoriesSettings).RelatedCategories
          : [];
        if (this.post.relatedCategoriesSettings.length) {
          this.post.relatedCategoriesSettings.forEach((element) => {
            this.settings.relatedPostsSettings.component.setting.selectedCategories.push(
              element.id
            );
          });
        }
      }

      this.catList = res.categoryList;
      this.tagList = res.tagList;
      this.media = res.mediaURLs;

      this.galleryImages = this.galleryImages || [];
      this.album = [];

      for (let i = 0; i < this.media.length; i++) {
        while (this.media[i].url.indexOf("\\") !== -1) {
          this.media[i].url = this.media[i].url.replace("\\", "/");
        }
        const src = this.media[i].url;
        const caption = this.settings.title
        const album = {
          src,
          caption,
          thumb: src,
         
        };
        this.album.push(album);

        this.galleryImages.push({
          small: this.media[i].url,
          medium: this.media[i].url,
          big: this.media[i].url,
        });
      }
      // this.setSocialMediaTags(this.post);
    }
  }
  // public setSocialMediaTags(post) {
  //   this.meta.removeTag('name = "twitter:card"');
  //   // this.meta.removeTag('name = "twitter:site"');
  //   // this.meta.removeTag('name = "twitter:creator"');
  //   this.meta.removeTag('name = "og:site_name"');
  //   this.meta.removeTag('name = "og:title"');
  //   this.meta.removeTag('name = "og:descripstion"');
  //   this.meta.removeTag('name = "og:url"');
  //   this.meta.removeTag('name = "og:image"');
  //   this.meta.removeTag('name = "og:type"');
  //   this.meta.removeTag('name = "keywords"');

  //   this.meta.addTag({ name: 'twitter:card', content: 'summary' });
  //   // this.meta.addTag({ name: "twitter:site", content: '@'+post })
  //   // this.meta.addTag({ name: "twitter:creator", content: '@'+post })
  //   this.meta.addTag({ name: 'og:site_name', content: '@' + post.title });
  //   this.meta.addTag({ name: 'og:title', content: post.title });
  //   this.meta.addTag({ name: 'keywords', content: post.keywords });
  //   this.meta.addTag({ name: 'og:description', content: post.metaDescription });
  //   this.meta.addTag({ name: 'og:url', content: location.href });
  //   this.meta.addTag({ name: 'og:image', content: post.mediaURLs[0].url });
  //   this.meta.addTag({ name: 'og:type', content: 'article' });
  //   // <meta name="twitter:site" content="@MurhafSousli">
  //   // <meta name="twitter:creator" content="@MurhafSousli">
  //   const addtionalMeta = JSON.parse(post.addtionalMetaTags) || [];
  //   if (addtionalMeta.length) {
  //     for (let i = 0; i < addtionalMeta.length; i++) {
  //       const element = addtionalMeta[i];
  //       if (element.name && !element.property) {
  //         this.meta.removeTag('name ="' + element.name + '" ');
  //         this.meta.addTag({ name: element.name, content: element.content });
  //       } else if (element.property && !element.name) {
  //         this.meta.removeTag('property ="' + element.property + '" ');
  //         this.meta.addTag({ property: element.property, content: element.content });
  //       } else {
  //         this.meta.removeTag('name ="' + element.name + '" ');
  //         this.meta.addTag({ name: element.name, property: element.property, content: element.content });
  //       }

  //     }
  //   }

  // }
  public setGalleryOptions() {
    this.galleryOptions = [
      {
        image: false,
        thumbnails: true,
        imageDescription:this.settings.title=== "false" ? false : true,
        width: "100%",
        imageArrowsAutoHide: false,
        thumbnailsArrowsAutoHide: false,
        height: "150px",
        arrowPrevIcon: "fa fa-angle-left",
        arrowNextIcon: "fa fa-angle-right",
        thumbnailsColumns: 4,
        imageAnimation: "slide",
        layout: "thumbnails-bottom",
        imageAutoPlay: false,
        imageAutoPlayInterval: 2000,
        imageAutoPlayPauseOnHover: false,
      },
    ];
  }
  public setThemeClassesAndColors() {
    if (this.settings.classFrom === "exist") {
      this.settings.existCssClass =
        this.settings.existCssClass !== undefined
          ? this.settings.existCssClass.toString().split(",").join(" ")
          : "";
    }
    if (this.settings.colorFrom === "exist") {
      this.settings.colorFrom =
        this.settings.colorFrom !== undefined ? this.settings.colorFrom : "";
    }
  }

  public open(index: number): void {
    this.lightBox.open(this.album, index, {
      wrapAround: false,
      showImageNumberLabel: true,
      positionFromTop: 60,
    });
  }

  public getImagesUrl(item) {
    return this.sinitizer.bypassSecurityTrustUrl(item.url);
    // return item.url;
  }

  public getThumbnailUrl(item) {
    if (item && item.url && item.url.length) {
      return item.url;
    } else {
      return "";
    }
  }
  getFancybox() {
    const oldLinks = document.getElementsByTagName("link");
    const oldJs = document.getElementsByTagName("script");
    for (let index = 0; index < oldLinks.length; index++) {
      const element = oldLinks[index];
      const getName = element.getAttribute("name");
      if (getName && getName.indexOf("facnyCSS") !== -1) {
        document.head.removeChild(element);
        index = index - 1;
      }
    }
    for (let index = 0; index < oldJs.length; index++) {
      const element = oldJs[index];
      const getName = element.getAttribute("name");
      if (getName && getName.indexOf("facnyJS") !== -1) {
        document.body.removeChild(element);
        index = index - 1;
      }
    }

    var css =
      "https://cdnjs.cloudflare.com/ajax/libs/fancybox/3.5.7/jquery.fancybox.css";
    var js =
      "https://cdnjs.cloudflare.com/ajax/libs/fancybox/3.5.7/jquery.fancybox.min.js";

    const facnyCSS = document.createElement("link");
    facnyCSS.setAttribute("rel", "stylesheet");
    facnyCSS.setAttribute("type", "text/css");
    facnyCSS.setAttribute("name", "facnyCSS");
    facnyCSS.setAttribute("href", css);
    document.head.appendChild(facnyCSS);

    const facnyJS = document.createElement("script");
    facnyJS.setAttribute("name", "facnyJS");
    facnyJS.setAttribute("src", js);
    document.body.appendChild(facnyJS);
  }
}
